<template>
<div class="relative">
    <button
      href="#"
      class="flex items-center HoverNav"
      @click="toggleVisibility"
      @keydown.space.exact.prevent="toggleVisibility"
      @keydown.esc.exact="hideDropdown"
      @keydown.shift.tab="hideDropdown"
    > 
    
   <flag  v-if="currentFlag"  :iso="(currentFlag == 'ES' || currentFlag == 'es') ? 'DO' : currentFlag" v-bind:squared=false class="h-8 w-8" />
   <span class="to-uppercase">{{currentFlag}}</span>
    <svg fill="currentColor"  viewBox="0 0 24 24" width="24" height="24"><path d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"></path></svg>
    </button>
    <transition name="dropdown-fade">
      <ul v-if="isVisible" ref="dropdown" style="z-index: 100000000;" class="absolute normal-case z-30 font-normal xs:left-0 lg:right-0 bg-white shadow overflow-hidden rounded w-48 border mt-2 py-1 lg:z-20">
        <li   v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.flag, entry.flag, entry.title)">
          <a
            href="#"
            ref="account"
            class="flex items-center px-3 py-3 hover:bg-gray-200"
            @keydown.up.exact.prevent=""
            @keydown.tab.exact="focusNext(false)"
            @keydown.down.exact.prevent="focusNext(true)"
            @keydown.esc.exact="hideDropdown"
          >
            <flag :iso="(entry.flag == 'ES' || entry.flag == 'es') ? 'DO' : entry.flag" v-bind:squared=false class="h-8 w-8" />
            <span class="ml-2 to-uppercase">{{entry.title}}</span>
          </a>
          
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>

import i18n from "@/Plugin/i18n";
import { Component, Vue } from "vue-property-decorator";
import LanguageService from "@/services/language.service";
@Component({ name: "drop-down" })
export default class DropDownLanguages extends Vue {
    languageService = new LanguageService();
  isVisible = false;
  focusedIndex = 0;
  currentFlag = 'do';
  currentName = 'do'; 
  languages = [];
  mounted() {
    this.getLanguages();
  }
  
  getLanguages(){
    this.languageService.getAll().then(msg =>{
      this.languages = msg.map(x => {
        return  {
          flag: x.key,
          title: x.name,
        }
      });
    })
  }
  changeLocale(locale, flag,key) {
    this.currentFlag = flag;
    this.currentName = key;
    this.$i18n.locale = locale;
    var msg = JSON.parse(localStorage.getItem("locales"));
    i18n.setLocaleMessage(locale, msg[locale]);
    localStorage.setItem("currentLocale", locale);
    this.toggleVisibility();    
  }
   toggleVisibility() {
      this.isVisible = !this.isVisible
    }

    startArrowKeys() {
      if (this.isVisible) {
        // this.$refs.account.focus()
        this.$refs.dropdown.children[0].children[0].focus()
      }
    }
    focusPrevious(isArrowKey) {
      this.focusedIndex = this.focusedIndex - 1
      if (isArrowKey) {
        this.focusItem()
      }
    }
    focusNext(isArrowKey) {
      this.focusedIndex = this.focusedIndex + 1
      if (isArrowKey) {
        this.focusItem()
      }
    }
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus()
    }
}
</script>
<style lang="scss" scoped>
.idioma {
  display: flex;
  flex-flow: column;
  background: none;
  border: none;
  font-size: 20px;
}
ul{
  padding: 10px;
  background: #F0F1F1;
  box-shadow: 0 6px 12px #b3b3b3;
  width: 240px;
}
li{
  display: flex;
  flex-flow: row;
}
span{
  margin-right: 30px;
  font-size: 20px;
}
.dropdown-fade-enter-active, .dropdown-fade-leave-active {
    transition: all .1s ease-in-out;
  }
  .dropdown-fade-enter, .dropdown-fade-leave-to {
    opacity: 0;
    transform: translateY(-12px);
  }
  button{
    border: none;
    background: #F0F1F1;
  }
  .to-uppercase {
    text-transform: uppercase;
  }
  .HoverNav{
     cursor: pointer;
  }
</style>
